import { CommonModule } from "@angular/common"
import { Component, Input, OnInit, OnChanges, SimpleChanges } from "@angular/core"
import { GloTagComponent } from "../../../shared/components/tag/tag.component"
import { RouterLink } from "@angular/router"
import { BookingState, SalonMode } from "../../../shared/models/salon.model"
import { Appointment } from "../../../shared/models/appointment.model"
import { environment } from "../../../../environments/environment"



@Component({
  selector: "salon",
  imports: [CommonModule, GloTagComponent, RouterLink],
  templateUrl: "./salon.component.html",
  styleUrl: "./salon.component.scss",
})
export class SalonComponent implements OnInit, OnChanges {
  @Input() mode: SalonMode = SalonMode.overview
  @Input() bookingState: BookingState | string = BookingState.confirmed
  @Input() appointments: Appointment[] = []   // ✅ full array instead of single appointment

  assetUrl = environment.assetBaseUrl

  modes = SalonMode
  bookingStates = BookingState

  ngOnInit(): void {
    console.log("[Salon Component] Initialized with appointments:", this.appointments)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["appointments"]) {
      console.log("[Salon Component] Appointments data changed:", {
        previous: changes["appointments"].previousValue,
        current: changes["appointments"].currentValue,
      })
    }
  }

  formatDateTime(dateString: string): string {
    if (!dateString) return "Date not available"

    try {
      const date = new Date(dateString)
      return date.toLocaleDateString("en-US", {
        weekday: "long",
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    } catch (error) {
      console.error("Error formatting date:", error)
      return "Invalid date"
    }
  }

  formatPrice(price: string | number): string {
    if (!price) return "$0.00"

    try {
      const numPrice = typeof price === "string" ? Number.parseFloat(price) : price
      return `$${numPrice.toFixed(2)}`
    } catch (error) {
      console.error("Error formatting price:", error)
      return "$0.00"
    }
  }

  // ✅ Add this exactly so Angular recognizes it
  trackByAppointmentId(index: number, appointment: Appointment): string | number {
    // use the correct unique property from your Appointment model
    return (appointment as any).id || (appointment as any).appointment_id || index;
  }
  
  getTagText(appointment: Appointment): string {
    if (!appointment?.status) return "Pending"

    switch (appointment.status.toLowerCase()) {
      case "confirmed":
        return "Confirmed"
      case "completed":
        return "Completed"
      case "cancelled":
        return "Booking Cancelled"
      case "pending":
        return "Pending"
      default:
        return "Pending"
    }
  }

  getTagState(appointment: Appointment): string {
    if (!appointment?.status) return "warning"

    switch (appointment.status.toLowerCase()) {
      case "confirmed":
        return "success"
      case "completed":
        return "default"
      case "cancelled":
        return "pending"
      case "pending":
        return "warning"
      default:
        return "warning"
    }
  }

  getSalonName(appointment: Appointment): string {
    return appointment?.salon?.name || "Salon Name Not Available"
  }

  getSalonAddress(appointment: Appointment): string {
    const salon = appointment?.salon
    if (!salon) return "Address not available"

    return `${salon.address || ""} ${salon.city || ""}`.trim() || "Address not available"
  }

  getAppointmentDateTime(appointment: Appointment): string {
    return appointment?.start_time
      ? this.formatDateTime(appointment.start_time)
      : "Date not available"
  }

  getAppointmentPrice(appointment: Appointment): string {
    return appointment?.total_price
      ? this.formatPrice(appointment.total_price)
      : "$0.00"
  }
}
